import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
} from './integrationImport';

export const getSalesforceAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/salesforceGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectSalesforce = async (companyId, userId) => {
  const { data } = await httpClient.post('/salesforceDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getSalesforceContacts = async (companyId) => {
  const { data } = await httpClient.post('/salesforceGetContacts', {
    companyId,
  });
  return data;
};

export const autoMapSalesforceEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/salesforceAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const exportAllEmployeesToSalesforce = async (companyId, teamId) => {
  const { data } = await httpClient.post('/salesforceExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const createAndMapSalesforceEmployee = async (
  companyId,
  prodaffUserId,
  displayName,
  email
) => {
  const { data } = await httpClient.post('/salesforceCreateAndMapEmployee', {
    companyId,
    prodaffUserId,
    displayName,
    email,
  });
  return data;
};

export const saveSalesforceMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/salesforceSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncSalesforceTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/salesforceSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const importSalesforceEmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/salesforceImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const previewSalesforceImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/salesforcePreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToSFImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'salesforce', onUpdate);

export const getSFImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'salesforce', logId);

export const subscribeToSFStatus = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc('salesforce')
    .onSnapshot(
      (doc) => {
        if (!doc.exists || !doc.data().connected) {
          onUpdate({
            connected: false,
            instanceUrl: null,
            connectedAt: null,
            connectedBy: null,
            employeeMappings: {},
            employeeMappingsUpdatedAt: null,
            lastSyncAt: null,
            lastSyncStats: null,
          });
          return;
        }
        const d = doc.data();
        onUpdate({
          connected: true,
          instanceUrl: d.instanceUrl || null,
          connectedAt: d.connectedAt?.toDate?.() ?? null,
          connectedBy: d.connectedBy || null,
          employeeMappings: d.employeeMappings || {},
          employeeMappingsUpdatedAt:
            d.employeeMappingsUpdatedAt?.toDate?.() ?? null,
          lastSyncAt: d.lastSyncAt?.toDate?.() ?? null,
          lastSyncStats: d.lastSyncStats || null,
        });
      },
      (err) => {
        console.error('SF status listener error:', err);
        onUpdate({
          connected: false,
          instanceUrl: null,
          connectedAt: null,
          connectedBy: null,
          employeeMappings: {},
          employeeMappingsUpdatedAt: null,
        });
      }
    );
};
